import { QuestionDateComponent } from './question-date.component';

export default angular
  .module('sfMobile.components.question-date', [
    'sfMobile.components.input-date',
  ])
  .component('sfQuestionDate', QuestionDateComponent).name;
